import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { DeleteInventoryCategoryResponseSchema } from "../response/DeleteInventoryCategoryResponse";

interface DeleteInventoryCategoryData {
    id: string;
}

export const useDeleteInventoryCategory = () => {
    return useMutation({
        mutationKey: ['inventory-categories', 'delete'],
        mutationFn: async (formData: DeleteInventoryCategoryData) => privateApi.delete(`/v4/inventory-category/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteInventoryCategoryResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory category data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory category data format");
            } else {
                console.error(`Failed to delete inventory category`, error);
                throw error;
            }
        }
    })
}
